import { render, staticRenderFns } from "./ContestSerialWritingsDialog.vue?vue&type=template&id=7ba4e460&scoped=true&"
import script from "./ContestSerialWritingsDialog.vue?vue&type=script&lang=js&"
export * from "./ContestSerialWritingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContestSerialWritingsDialog.vue?vue&type=style&index=0&id=7ba4e460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba4e460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VLayout,VSpacer})
